import React from 'react'
import { SkeletonStyle } from './styles'
import styled from '@emotion/styled'
import { PAGE_BREAKPOINTS } from 'parameters/index'
import { Optional } from 'lib/types'

/**
 * Skeleton for a single line of text
 * @param {number} [width]
 * @constructor
 */
export const TextLineSkeleton = ({ width }: { width?: number }): JSX.Element => (
	<TextLineStyle width={width}>&zwnj;</TextLineStyle>
)

const TextLineStyle = styled(SkeletonStyle)<{ width?: number }>`
	// eslint-disable-next-line sonarjs/no-nested-template-literals
	width: ${({ width }): string => (width ? `${width}px` : '100%')};
	max-width: 100%;
`

type Size = 'small' | 'large'
/**
 * Skeleton for a title or something small
 * @constructor
 */
interface TitleSkeletonProps {
	size?: Size
}
const styleFromSize = (size: Optional<Size>) => {
	switch (size) {
		case 'small':
			return { width: '30%' }
		case 'large':
			return { width: '80%' }
		case undefined:
			return {}
	}
}
export const TitleSkeleton = ({ size }: TitleSkeletonProps): JSX.Element => (
	<TitleStyle style={styleFromSize(size)}>&zwnj;</TitleStyle>
)

const TitleStyle = styled(SkeletonStyle)`
	width: 40%;
	@media only screen and (${PAGE_BREAKPOINTS.DESKTOP_SMALL}) {
		width: 60%;
	}
`
